<template>
    <div class="customConsult">
        <el-form ref="ruleFormRef" :model="ruleForm" :rules="rules" status-icon >
            <div class="label">培训主体<span>*</span></div>
            <el-form-item prop="pxzt">
                <el-select v-model="ruleForm.pxzt" filterable placeholder="请选择培训主体" no-data-text=暂无数据>
                    <el-option v-for="item in pxztList" :key="item._id" :label="item.pxzt" :value="item._id" />
                </el-select>
            </el-form-item>
            <div class="label">培训类型<span>*</span></div>
            <el-form-item prop="pxlx">
                <el-select v-model="ruleForm.pxlx" filterable placeholder="请选择培训类型" no-data-text=暂无数据>
                    <el-option v-for="item in offlineTitList" :key="item._id" :label="item.pxfl" :value="item._id"/>
                </el-select>
            </el-form-item> 
            <div class="label">公司名称</div>
            <el-form-item prop="gsmc">
                <el-input v-model="ruleForm.gsmc"  placeholder="请输入公司名称" />
            </el-form-item>
            <div class="label">公司职务</div>
            <el-form-item  prop="gszw">
                <el-input v-model="ruleForm.gszw "  placeholder="请输入公司职务" />
            </el-form-item>
            <div class="label">姓 {{ '　'.repeat(2)  }}名<span>*</span></div>
            <el-form-item prop="xm">
                <el-input v-model="ruleForm.xm"  placeholder="请输入姓名" />
            </el-form-item>
            <div class="label">手机号码<span>*</span></div>
            <el-form-item prop="lxsjh" >
                <el-input v-model="ruleForm.lxsjh"  placeholder="请输入联系手机号" />
            </el-form-item>
            <div class="label">咨询内容<span>*</span></div>
            <el-form-item prop="zxnr"  >
                <el-input v-model="ruleForm.zxnr" :autosize="{ minRows: 7, maxRows: 7 }" type="textarea" placeholder="请输入想要咨询的服务内容" />
            </el-form-item>
            <el-form-item>
                <div :class="['wui-background-color-' + themeColor]" class="btn" @click="submitForm(ruleFormRef)">
                    立即提交咨询
                </div>
            </el-form-item>
        </el-form>
    </div>
</template>
 
<script>
import { getCurrentInstance,ref,onMounted} from "vue";
export default {
    name: "secondPage",
    props:{
        themeColor: {
            type: String,
            default: 'blue'
        },
        offlineTitList:{
            type:Array,
            default:()=>([])
        }
    },
    setup(props) {
        const { proxy } = getCurrentInstance();
        const pxztList=ref([
            {
                pxzt:'政府培训',
                _id:'政府培训'
            },{
                pxzt:'企业培训',
                _id:'企业培训'
            },{
                pxzt:'个人培训',
                _id:'个人培训'
            }
        ])
        const ruleFormRef=ref(null)
        const ruleForm= ref({pxlx:'',pxzt:'',gsmc:'',gszw:'',xm:'',lxsjh:'',zxnr:''})
        const rules = ref({
            pxzt: [
                { required: true, message: "请选择培训主体", trigger: "change" }
            ],
            pxlx:[
                { required: true, message: "请选择培训类型", trigger: "change" }
            ],
            xm: [
                { required: true, message: "请输入姓名", trigger: "blur" },
            ],   
            lxsjh: [
                { required: true, message: "请输入联系手机号", trigger: "blur" },
            ],
            zxnr: [
                { required: true, message: "请输入咨询内容", trigger: "blur" },
            ],
        })
        const updateTheme = () => {
            document.documentElement.style.setProperty('--el-color-primary', props.themeColor);
        }
        updateTheme()
        //提交表单
        const submitForm = async (formEl) => {
            if (!formEl) return
            await formEl.validate((valid, fields) => {
                if (valid) {
                    addFn()
                } else {
                    console.log('error submit!', fields)
                }
            })
        }
        //保存数据
        const addFn=()=>{ 
            proxy.$request({
                url: "QPSTZX_PXFW_PXFWZXADD",
                method: "post",
                data:ruleForm.value
            }).then((res) => {
                if (res.data.code == "000") {
                    proxy.$message({
                        type: "success",
                        message: "提交成功"
                    });
                    ruleForm.value={}
                    ruleFormRef.value.resetFields();
                }
            }).catch((err) => {
                console.log(err);
            });
        }
       
        onMounted(() => {

        });
        return {
            pxztList,
            ruleForm,
            ruleFormRef,
            rules,
            submitForm,
        };
    },
};
</script>

<style lang="less" scoped>
    .customConsult {
        .label{
            font-weight: 400;
            font-size: 13px;
            color: #1A1A1A;
            line-height: 18px;
            margin-bottom: 10px;
            span{
                color: #FF0000;
                font-weight: 600;
                font-size: 12px;
                margin-left: 2px;
            }
        }
        :deep(.el-input__inner::placeholder),
        :deep(.el-textarea__inner::placeholder) {
            font-weight: 400;
            font-size: 12px;
            color: #B2B3BA;
        }
        :deep(.el-select .el-select__placeholder.is-transparent ) {
            font-weight: 400;
            font-size: 12px;
            color: #B2B3BA;
        }
    }
</style>